import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import Separator from "app/pages/.shared/Separator";
import IconWarning from "app/pages/.shared/static/icons/IconWarning";
import { htmlSanitize } from "app/utils/sanitize";

const InsuranceContentNoInsurance = ({ insurance }) => {
	return (
		<div className="insurances__free">
			<Separator />

			<header className="insurances__no-header">
				<FormattedMessage id="payment.no.insurance.header.label" />
			</header>

			<section className="insurances__details">
				<div className="insurances__details-no-insurance">
					<div dangerouslySetInnerHTML={{ __html: htmlSanitize(insurance?.details) }} />
					<div>
						<IconWarning />
					</div>
				</div>
			</section>
		</div>
	);
};

InsuranceContentNoInsurance.propTypes = {
	insurance: PropTypes.object.isRequired,
};

export default InsuranceContentNoInsurance;
